<template>
  <div class="mainBan">
    <!-- <el-dialog
      title="提示"
      :visible="isShow"
      class="certificationInfoContainer"
      width="420px"
      :close-on-click-modal="allowClose"
      :close-on-press-escape="allowClose"
      :show-close="allowClose"
      :before-close="beforeClose"
    >
      <p class="info">{{ data.ban_reason }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toAppeal">人工申诉</el-button>
      </span>
    </el-dialog> -->

    <el-dialog
      title="账号异常"
      :visible="appeal && isShow"
      class="appealContainer"
      width="420px"
      top="5vh"
      :before-close="beforeCloseAppeal"
    >
      <iframe :src="appealUrl"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import { SWUSER_HOST } from "../constants/apiHosts";

export default {
  name: "banDialog",
  data() {
    return {
      data: {},
      appeal: false,
      appealUrl: "",
      token: "",
    };
  },
  props: {
    isShow: {
      type: Boolean,
      default: () => false,
    },
    allowClose: {
      type: Boolean,
      default: () => false,
    },
  },
  mounted() {
    window.onmessage = this.finishFn;
  },
  destroyed() {
    window.onmessage = null;
  },
  methods: {
    finishFn(e) {
      if (e.data == "appealFinished") {
        this.$message({
          type: "success",
          message: "提交成功!",
        });

        this.appeal = false;
        this.$emit("closeBan");
      }
    },
    getReason(token) {
      this.token = token;
      this.toReason();
      // this.$axios
      //   .get(`${SWUSER_HOST}/service/userban/getUserBanInfo?token=${token}`)
      //   .then((res) => {
      //     if (res.data.code == 0) {
      //       this.data = res.data.data;

      //       this.token = token;
      //     } else {
      //       console.log(res.data.msg);
      //     }
      //   });
    },
    toReason() {
      this.appealUrl = `https://m.${
        location.href.indexOf("topnews.cn") >= 0 ||
        location.href.indexOf("topnews.cn") >= 0
          ? "topnews.cn"
          : "dingnews.net"
      }/a/pages/abutment/abnormal?token=${this.token}&isPc=1`;
      this.appeal = true;
    },
    toAppeal() {
      this.appealUrl = `https://m.${
        location.href.indexOf("topnews.cn") >= 0 ||
        location.href.indexOf("topnews.cn") >= 0
          ? "topnews.cn"
          : "dingnews.net"
      }/a/pages/abutment/appeal?token=${this.token}`;
      this.appeal = true;
    },
    beforeClose() {
      this.$emit("closeBan");
    },
    beforeCloseAppeal() {
      this.appeal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.mainBan {
  .certificationInfoContainer {
    /deep/.el-dialog__header {
      padding: 20px 32px;

      .el-dialog__title {
        font-size: 16px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #333333;
        line-height: 22px;
      }
    }

    /deep/.el-dialog__body {
      padding: 12px 32px 30px 32px;

      .info {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }
    }
  }

  .appealContainer {
    /deep/.el-dialog__body {
      padding: 0 10px;
      height: 700px;

      iframe {
        width: 100%;
        height: 680px;
      }
    }
  }
}
</style>
